import React from 'react';
import { motion } from 'framer-motion';
import { SiblingFigure } from './characters/SiblingFigure';
import { siblings } from '../data/siblings';
import type { SiblingRole } from '../types/snak';
interface SiblingChoiceGridProps {
  selected: SiblingRole | null;
  onSelect: (role: SiblingRole) => void;
}
export function SiblingChoiceGrid({
  selected,
  onSelect
}: SiblingChoiceGridProps) {
  return <div className="grid grid-cols-2 gap-3" data-id="element-234" data-mp="7mo5ic55kfh4">
      {siblings.map((sibling, i) => {
      const isSelected = selected === sibling.id;
      const dimmed = selected !== null && !isSelected;
      return <motion.button key={sibling.id} type="button" onClick={() => onSelect(sibling.id)} initial={{
        opacity: 0,
        y: 18,
        scale: 0.94
      }} animate={{
        opacity: dimmed ? 0.35 : 1,
        y: 0,
        scale: isSelected ? 1.03 : 1
      }} transition={{
        delay: selected ? 0 : 0.12 + i * 0.07,
        type: 'spring',
        stiffness: 320,
        damping: 24
      }} whileHover={{
        y: -3
      }} whileTap={{
        scale: 0.96
      }} style={{
        backgroundColor: sibling.surface
      }} className={['group relative flex flex-col items-center overflow-hidden rounded-[22px] px-3 pb-4 pt-3 text-center', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-background', isSelected ? 'ring-2 ring-background shadow-[0_12px_30px_-14px_rgba(1,51,43,0.55)]' : 'ring-1 ring-[rgba(1,51,43,0.12)]'].join(' ')} aria-pressed={isSelected} data-id="element-235" data-mp="hk2ejqoqy1ze" data-mpi={i}>
            <div className="relative h-[104px] w-full" data-id="element-236" data-mp="1p8ss5dntmkf4">
              <motion.div className="absolute inset-0 flex items-end justify-center" animate={isSelected ? {
            y: [0, -6, 0],
            rotate: [0, -1.5, 0]
          } : {
            y: 0,
            rotate: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} data-id="element-237" data-mp="1pa44w2z8v2id">
                <SiblingFigure role={sibling.id} className="h-[104px] w-auto" data-id="element-238" data-mp="1lqln2fo39nyw" />
              </motion.div>
            </div>
            <span className="mt-1 font-heading text-[15px] leading-tight text-background" data-id="element-239" data-mp="180i4pzsbyeeq">
              {sibling.label}
            </span>
            <span className="mt-0.5 font-body text-[11px] leading-snug" style={{
          color: sibling.accent
        }} data-id="element-240" data-mp="1byzd0mnhluxq">
              {sibling.trait}
            </span>
          </motion.button>;
    })}
    </div>;
}